import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconKeyboardCable: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconKeyboardCable"><Path fillRule="evenodd" clipRule="evenodd" d="M7 6H19V2H17V4H5V8H1V22H23V8H7V6ZM9 16H15V18H9V16ZM7 12H5V14H7V12ZM5 16H7V18H5V16ZM11 12H9V14H11V12ZM13 12H15V14H13V12ZM19 12H17V14H19V12ZM17 16H19V18H17V16Z" fill="currentColor"/></CentralIconBase>;
});

export default IconKeyboardCable;
